import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20minimalist%20artistic%20studio%20space%20with%20warm%20ambient%20lighting%2C%20soft%20neutral%20cream%20and%20beige%20tones%2C%20elegant%20abstract%20composition%20with%20flowing%20fabric%20textures%2C%20subtle%20geometric%20patterns%2C%20warm%20golden%20accents%2C%20serene%20and%20sophisticated%20atmosphere%2C%20fine%20art%20photography%20style%20with%20gentle%20bokeh&width=1800&height=900&seq=hero-bg-2026&orientation=landscape"
        alt="捆绑调教完全指南"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 mb-6 leading-tight">
          捆绑调教完全指南
        </h1>
        <p className="text-base md:text-lg text-background-50/90 max-w-2xl mx-auto mb-8 leading-relaxed">
          围绕捆绑调教提供系统性内容，涵盖安全须知、道具选择、基础到进阶技巧，
          以及双方信任建立与事后关怀，帮助成人伴侣在安全、自愿、理性的前提下探索捆绑调教的乐趣与边界。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/safety"
            className="px-6 py-3 bg-primary-500 text-background-50 rounded-full font-medium text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            从安全须知开始
          </Link>
          <Link
            to="/category/basics"
            className="px-6 py-3 bg-background-50/20 backdrop-blur-sm text-background-50 border border-background-50/30 rounded-full font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览基础技巧
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-2 md:grid-cols-3 gap-4 max-w-lg mx-auto">
          {[
            { label: '安全第一', icon: 'ri-shield-check-line' },
            { label: '自愿原则', icon: 'ri-heart-line' },
            { label: '循序渐进', icon: 'ri-stack-line' },
          ].map((item) => (
            <div key={item.label} className="flex items-center gap-2 justify-center text-background-50/80">
              <span className="w-6 h-6 flex items-center justify-center">
                <i className={`${item.icon} text-sm`}></i>
              </span>
              <span className="text-sm font-medium whitespace-nowrap">{item.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}